import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo, useRef, useCallback } from 'react';
import classnames from 'classnames';
import capitalize from 'lodash/capitalize';
import { ModalStyled, ModalContainer, PaperStyled } from './Dialog.styles';
import { setRef } from '../utils/withForwardedRef';
var Dialog = forwardRef(function (_a, ref) {
  var className = _a.className,
      open = _a.open,
      fullWidth = _a.fullWidth,
      width = _a.width,
      _b = _a.scroll,
      scroll = _b === void 0 ? 'paper' : _b,
      TransitionProps = _a.TransitionProps,
      paperProps = _a.PaperProps,
      children = _a.children,
      otherProps = __rest(_a, ["className", "open", "fullWidth", "width", "scroll", "TransitionProps", "PaperProps", "children"]);

  var rootClassName = classnames("scroll".concat(capitalize(scroll)), className);
  var paperClassName = classnames({
    fullWidth: fullWidth
  }, paperProps && paperProps.className);
  var paperRef = useRef(null);
  var handlePaperRef = useCallback(function (el) {
    paperRef.current = el;

    if (paperProps === null || paperProps === void 0 ? void 0 : paperProps.ref) {
      setRef(paperProps.ref, el);
    }
  }, [paperProps === null || paperProps === void 0 ? void 0 : paperProps.ref]);
  return _jsx(ModalStyled, __assign({
    className: rootClassName,
    open: open,
    ref: ref,
    role: "dialog",
    TransitionProps: __assign(__assign({
      timeout: 300,
      classNames: 'fade'
    }, TransitionProps), {
      nodeRef: paperRef
    }),
    ContainerComponent: ModalContainer
  }, otherProps, {
    children: _jsx(PaperStyled, __assign({
      shadow: "dialog",
      background: "primary",
      role: "document"
    }, paperProps, {
      ref: handlePaperRef,
      style: width !== undefined ? __assign({
        width: width
      }, paperProps && paperProps.style || {}) : paperProps && paperProps.style,
      className: paperClassName
    }, {
      children: children
    }))
  }));
});
export default memo(Dialog);